import { createContext } from 'react';
import { StoreRef } from './types';

export const MultiChatContext = createContext<StoreRef | null>(null);
